import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CalendarCheck, CalendarClock, CalendarX, ChevronRight, UserX } from 'lucide-react';
import clsx from 'clsx';
import { SCHEDULER_TILE_STATE, schedulerListRoute } from '@utils/schedulerDashboardRoutes';
import type { SchedulerQuickActionsData } from '@app-types';
import styles from './ProgramLeadQuickActions.module.css';
import tones from './AssessorQuickActions.module.css';

interface SchedulerQuickActionsProps {
  data: SchedulerQuickActionsData | undefined;
  isLoading: boolean;
}

const SchedulerQuickActions: React.FC<SchedulerQuickActionsProps> = ({ data, isLoading }) => {
  const navigate = useNavigate();

  const actions = [
    {
      label: 'Pending CO/CM',
      count: data?.pending_co_cm,
      icon: UserX,
      tone: tones.iconWarning,
      route: schedulerListRoute(SCHEDULER_TILE_STATE.pendingCoCm)
    },
    {
      label: 'Available to Schedule',
      count: data?.available_to_schedule,
      icon: CalendarCheck,
      tone: tones.iconInfo,
      route: schedulerListRoute(SCHEDULER_TILE_STATE.availableToSchedule)
    },
    {
      label: 'Pending Scheduling',
      count: data?.pending_scheduling,
      icon: CalendarClock,
      tone: tones.iconInfo,
      route: schedulerListRoute(SCHEDULER_TILE_STATE.pendingScheduling)
    },
    {
      label: 'Declined/Tentative Meetings',
      count: data?.declined_tentative_meetings,
      icon: CalendarX,
      tone: tones.iconDanger,
      route: schedulerListRoute(SCHEDULER_TILE_STATE.declinedTentative)
    }
  ];

  return (
    <div className={styles.quickActionsContainer}>
      <div className={styles.actionsGrid}>
        {actions.map((action) => {
          const IconComponent = action.icon;
          return (
            <button
              type="button"
              key={`action-${action.label}`}
              className={clsx(styles.actionTile, tones.tile)}
              onClick={() => navigate(action.route)}
            >
              <div className={clsx(styles.actionIcon, action.tone)}>
                <IconComponent size={24} />
              </div>
              <div className={styles.actionContent}>
                <p className={styles.actionLabel}>{action.label}</p>
                <p className={styles.actionCount}>{isLoading ? '–' : (action.count ?? 0)}</p>
              </div>
              <ChevronRight size={20} className={styles.actionArrow} />
            </button>
          );
        })}
      </div>
    </div>
  );
};

export { SchedulerQuickActions };
